export { default as ShareLinkForm } from './ShareLinkForm';



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageAdPage/ShareLinkForm/index.ts